import { Box, Card, CardContent } from '@atgfr8/atg-ui-tailwind';
import { LoadTrackingT } from '@store/orders';
import { formatDateString } from '@utils/dateFormat';

type PropsT = {
  tracking: LoadTrackingT;
};

export const TrackingCard = (props: PropsT) => {
  return (
    <Card class="shrink-0 grow-0 text-white bg-[#000000DE]! mb-2">
      <CardContent class="h-[60px] p-[5px]!">
        <Box>
          In {props.tracking.city ?? '-'}, {props.tracking.state ?? '-'}
        </Box>
        <Box class="text-xs">
          {formatDateString(props.tracking.locationTime, 'DD t')}
        </Box>
        <Box class="text-xs">{props.tracking.trackingSource}</Box>
      </CardContent>
    </Card>
  );
};
